<template>
  <div></div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useHelpers } from '@/composables/useHelpers'
import { removeStorage } from '@/composables/useStorage'

const { replace } = useRouter()
const { removeCookie } = useHelpers()
removeStorage('session', 'user')
removeCookie('access_token')
replace('/auth')
</script>

<style scoped></style>
